import { render, staticRenderFns } from "./MyLicenses.vue?vue&type=template&id=26debd1e&scoped=true"
import script from "./MyLicenses.vue?vue&type=script&lang=ts"
export * from "./MyLicenses.vue?vue&type=script&lang=ts"
import style0 from "./MyLicenses.vue?vue&type=style&index=0&id=26debd1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26debd1e",
  null
  
)

export default component.exports